import React, { useEffect, useState } from "react";
import Icon from "../../../common/components/Icon";
import getUserTransactions from "../../../api/getUserTransactions";
import { t } from "i18next";

import EmptyState from "../../../components/emptystate/EmptyState";
import Loading from "../../../common/components/Loading";

function PaymentHistory({ setActiveTab, embedded }) {
    const [transactions, setTransactions] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchTransactions = async () => {
            try {
                const data = await getUserTransactions();
                setTransactions(data.transactions);
            } catch (err) {
                setError("Ошибка загрузки данных");
            } finally {
                setLoading(false);
            }
        };
        fetchTransactions();
    }, []);

    const formatDate = (isoString) => {
        const date = new Date(isoString);
        return date.toLocaleString("ru-RU", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    const getTransactionDescription = (type) => {
        const types = {
            balance_top_up: t('wallet_top_up'),
            refund: t('refound'),
        };
        return types[type] || t('transaction');
    };

    const formatAmount = (amount, type) => {
        const sign = type === "refund" ? "-" : "+";
        const numeric = Number(amount);
        const formatted = Number.isFinite(numeric) ? numeric.toLocaleString("ru-RU") : amount;
        return `${sign} ${formatted} ₸`;
    };

    return (
        <div className="w-full">
            {!embedded && <Icon src="backicon" onClick={() => setActiveTab(null)} className="block md:hidden fixed left-5 top-[23px] cursor-pointer z-[102]" />}

            <div className="bg-white rounded-2xl p-6">
                {loading && <Loading />}
                {error && <p className="text-red-500 text-sm">{error}</p>}

                {!loading && !error && transactions.length === 0 && (
                    <EmptyState title={t('no_nothing')} subtitle={t('no_history_paynents')} />
                )}

                {!loading && !error && transactions.length > 0 && (
                    <ul className="flex flex-col gap-3">
                        {transactions.map((tx) => {
                            const isRefund = tx.transaction_type === "refund";
                            return (
                                <li key={tx.id} className="flex items-center justify-between p-4 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors">
                                    <div className="flex items-center gap-3">
                                        <div className={`w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0
                                            ${isRefund ? 'bg-red-100' : 'bg-[#147F26]/10'}`}>
                                            <span className={`text-lg font-bold ${isRefund ? 'text-red-500' : 'text-[#147F26]'}`}>
                                                {isRefund ? '−' : '+'}
                                            </span>
                                        </div>
                                        <div>
                                            <p className="text-sm font-semibold text-gray-800">
                                                {getTransactionDescription(tx.transaction_type)}
                                            </p>
                                            <p className="text-xs text-gray-400 mt-0.5">{formatDate(tx.created_at)}</p>
                                        </div>
                                    </div>
                                    <p className={`text-sm font-bold ${isRefund ? 'text-red-500' : 'text-[#147F26]'}`}>
                                        {formatAmount(tx.amount, tx.transaction_type)}
                                    </p>
                                </li>
                            );
                        })}
                    </ul>
                )}
            </div>
        </div>
    );
}

export default PaymentHistory;
